<template>
    <div>
        <v-row
            v-for="(row, index) in rows"
            :key="index"
            no-gutters
            :class="[rowClasses(row), 'align-center justify-center']"
        >
            <v-avatar
                v-if="row.color"
                :color="row.color"
                size="10"
                style="margin-top: 2px"
                class="mr-2"
            />
            <div>
                <span :class="labelClasses(row)">{{ row.label }}</span>
            </div>
            <v-spacer/>
            <div>
                <span :class="valueClasses(row)" :style="{'color': row.valueColor}">
                    {{ row.value }}
                </span>
            </div>
        </v-row>
    </div>
</template>

<script>

export default {
    name: 'InfoRows',
    props: {
        rows: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {

        const labelClasses = (row) => {
            return row.labelClasses || ['body-2']
        }

        const valueClasses = (row) => {
            return row.valueClasses || ['body-2']
        }

        const rowClasses = (row) => {
            return row.rowClasses ? row.rowClasses : []
        }

        return {
            labelClasses,
            valueClasses,
            rowClasses
        }
    }
}

</script>

<style scoped lang="scss">

</style>